let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i7U3b")).then(() => parcelRequire('cVDSh'));